import axios from 'axios';
import SuiVue from 'semantic-ui-vue';
import Vue from 'vue';
import VueHighcharts from 'vue-highcharts';

import 'semantic-ui-css/semantic.min.css';

import router from '@/router';
import store from '@/store';

import App from '@/App.vue';

Vue.use(SuiVue);
Vue.use(VueHighcharts);

Vue.prototype.$http = axios;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
